<script>
    import Cookies from 'js-cookie'
    import { Form } from '../../../../helpers/Form/Form'

    export default {
        props: {
            company: {
                type: Object
            },
            initialStep: Number
        },
        data() {
            let currentStep = this.initialStep
            let email = this.company.email || null
            let phone_number = this.company.phone_number || null
            return {
                currentStep,
                form: new Form({
                    forget: false,
                    email,
                    phone_number
                })
            }
        },
        watch: {
            initialStep: {
                handler(val,oldVal){
                    this.currentStep = val
                    //console.log(val,oldVal)
                }
            }
        },
        computed: {
            step() {
                return `step-${this.currentStep}`
            }
        },
        methods: {
            onCloseModal() {
                this.$set(this.form, 'forget', true)

                this.form
                    .submit('put', route('companies.profile-update', this.company.id))
                    .then(response => {
                        $("#confirmRegistration").modal('hide')
                    })
            },
            onNextSlide() {
                if (this.currentStep < 3) {
                    this.currentStep++
                } else {
                    this.form
                        .submit('put', route('companies.profile-update', this.company.id))
                        .then(({redirect_course}) => {
                            $("#confirmRegistration").modal('hide')
                            window.alerts.success('Informazioni salvate correttamente!')
                            if (this.initialStep === 1) {
                                setTimeout(() => {
                                    location.href = `${redirect_course}?modal=course-smart-modal`
                                }, 500)
                            }
                        })
                        .catch(error => {
                            window.alerts.error('Attenzione! Controlla i campi segnati in rosso')
                        })
                }
            },
            onPrevSlide() {
                if (this.currentStep > 1) {
                    this.currentStep--
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/company/dashboard/partials/UnbounceConfirmRegistrationModal.vue